import React from 'react';

export function MenuItemLabel({ text }: any) {
  return <span className="bp4-menu-item-labeler">{text}</span>;
}
